module.exports = __webpack_public_path__ + "img/wedcr3.ac64ce4b.jpg";